<template>
    <CModal
      title="Cargar Archivo"
      :color="color"
      size="lg"
      :show.sync="uploadModal"
      style="z-index: 100001"
    >   
        <CForm id="special_file_form" method="POST" enctype="multipart/form-data">
            <CRow>
              <CCol md="12">
                <CInputFile
                  :key="fileInputKey"
                  ref="inputFile"
                  name="file"
                  id="file"
                  :custom="true"
                  accept="image/*,.pdf"
                  @change="onFileChange"
                />
              </CCol>
            </CRow>
            <CRow v-if="imagePreview" class="mt-3">
             <CCol md="12">
                <div
                  style="width: 150px; height: 150px; border: 1px solid #ddd; padding: 10px; display: flex; flex-direction: column; align-items: center; justify-content: center; text-align: center;"
                >
                  <template v-if="imagePreview.isPDF">
                    <i class="fas fa-file-pdf fa-3x text-danger"></i>
                    <small style="margin-top: 8px; font-size: 12px; word-break: break-word;">{{ imagePreview.name }}</small>
                  </template>
                  <template v-else>
                    <img :src="imagePreview.url" alt="Preview" style="max-width: 100%; max-height: 120px;" />
                  </template>
                </div>
              </CCol>  
            </CRow>
        </CForm>
        <template #footer>
          <CButton @click="closeModal" color="secondary">Cancelar</CButton>
          <CButton @click="upload" :color="color">Cargar Archivo</CButton>
        </template>
    </CModal>
</template>

<script>
import students from '../../../services/students';
import ws from '../../../services/travels';
import store from '../../../store';

export default {
  name: 'FileMultipleUpload',
  components: {
    
  },
  props: {

  },
  data () {
    return {
      uploadModal: false,
      color: "info",
      travel_id: 0,
      travel_form_id: 0,
      response_id: 0,
      student_id: 0,
      question_key: 0,
      label: "Archivo:",
      item: false,
      field: false,
      imagePreview: null,
      fileInputKey: 0, // <-- para forzar re-render del input
      file: null,
      type: ''
    }
  },
  mounted: async function() {

  },
  methods: {
    resetFileInput () {
      // limpiar el input real
      const input = this.$refs.inputFile?.$el.querySelector('input[type="file"]')
      if (input) input.value = null

      this.file = null
      if(this.imagePreview && this.imagePreview.url) URL.revokeObjectURL(this.imagePreview.url)
      this.imagePreview = null

      // forzar re-render del componente input file
      this.fileInputKey++
    },
    onFileChange() {
      const input = this.$refs.inputFile.$el.querySelector('input[type="file"]')
      const file = input.files && input.files[0]
      if (!file) return

      if(this.imagePreview && this.imagePreview.url) URL.revokeObjectURL(this.imagePreview.url)
      const isPDF = file.type === 'application/pdf'
      this.file = file
      this.imagePreview = {
        isPDF,
        name: file.name,
        url: isPDF ? null : URL.createObjectURL(file),
      }
    },
    show (title, student_id, item, field) {
      this.uploadModal = true;
      this.color = "info";
      
      this.label = field.label;

      this.travel_id = item.travel_id;
      this.travel_form_id = item.travel_form_id !== undefined ? item.travel_form_id : 0;
      this.student_id = student_id;
      this.response_id = item.response_id != undefined ? item.response_id : 0;
      this.question_key = field.key;

      this.imagePreview = null;
      this.file = null;
      this.fileInputKey = 0;

      this.item = item;
      this.field = field;
    },
    async upload () {
      this.loading();
        const form = document.getElementById("special_file_form");
        const formData = new FormData(form);

        formData.append("travel_id", this.travel_id);
        formData.append("student_id", this.student_id);
        formData.append("question_id", this.question_key);
        formData.append("code", this.item.code);
        let response = false;

        response = await ws.uploadPassportOrVisa(formData);

        if(response.type == "success"){
          this.field.student_id = this.student_id;
          this.$emit("upload", this.item, this.field, response.data );
        }

        this.showToast(response.type, response.message);

      this.loaded();
      this.closeModal();
    },
    closeModal () {
      this.uploadModal = false;
    },
    showToast(type, message){
      store.commit('toast', {color: type, message: message});
    },
    loading(){
      store.commit('loading');
    },
    loaded(){
      store.commit('loaded');
    }
  }
}
</script>